<template>
    <div style="height:100%; width:100%">
        <div v-if="percenttillfinished >= 100">
        <h1>{{ translation.STR_TEST_IN_PROGRESS }}</h1>     
        </div>
        <div v-else class="wait">
            <div class="progressinfo">
            <div><h1>{{ translation.STR_TEST_IN_PROGRESS }}</h1></div>
            <div><h3>{{translation.STR_REMAINING_TIME}} {{ countdown }}</h3></div><br/>
            <div><progress max="100" :value="percenttillfinished" /></div>
            </div>
        </div>
        <br/>
        <br/>
    </div>
</template>
<script>
const { uuid } = require('uuidv4');

export default ({
    props: [ 'online', 'translation', 'hasResults', 'token', 'testrunning'],
    created() {
        this.test = this.$route.params.test;
        let { dev = 16 } = this.$route.params;

        if(dev == 16) {
            this.$route.params.wells.rows.forEach((i) => {
                i.wells.filter(e => e.barcode !== null).forEach((i) => {
                    i.result = false;
                    i.ct = false;
                    i.cc = false;
                    this.wells.push(i);
                })
            })
        } else {
            this.$route.params.wells.filter(e => e.barcode !== null).forEach((w) => {
                this.wells.push({
                    fpos: w.fpos,
                    barcode: w.barcode,
                })
            })
        }

        var xml_output = "";
        this.wells.forEach((well) => {
            xml_output+='<Well Name="'+well.fpos+'" SampleId="'+well.barcode+'"><Tasks><Task DetectorId="1" Type="Unknown" /><Task DetectorId="2" Type="Unknown" /></Tasks></Well>\n';
        })

        this.debug = xml_output.trim();
        this.xmlconfig = btoa(xml_output.trim());
        this.testid = uuid();
        console.log(this.wells);
        //this.axios.post("https://fax.reisenbauer.at/procomcure/newtest.php?testid="+this.testid+"&token="+this.token, {wells: this.wells })
        this.axios.post("https://poc.m26.at/procomcure/newtest.php?testid="+this.testid+"&token="+this.token, {wells: this.wells })
        this.axios.post("http://127.0.0.1:8441/procomcure/?cmd=config&test="+this.testid, { xml: this.xmlconfig })
        .then((r) => {            
                this.axios.get("http://127.0.0.1:8441/procomcure/?cmd=rungene", { xml: this.xmlconfig })
        })
    },
    computed: {
        percenttillfinished() {
            var perc = this.currenttime*100/this.testduration;
            return perc;
        },
        countdown() {
            var d = Number(this.testduration-this.currenttime);
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            if(h < 10) h="0"+h;
            if(m < 10) m="0"+m;
            if(s < 10) s="0"+s;
            return h+":"+m+":"+s;          
        }
    },
    mounted() {
        setInterval(() => {
            this.currenttime++;
        }, 1000)
    },
    watch: {
        currenttime() {
            var diff = this.testduration-this.currenttime;
            if(this.hasResults == true) {
                this.$router.push({
                    name: 'results',
                    params: {
                        wells: this.wells,
                        test: this.test,
                        testid: this.testid,
                    }
                })
            }
        }
    },
    methods: {
         calcPosition(w) {
            var p = null;
            var t = w.id;
            if(w.row == 1) p="A";
            if(w.row == 2) p="B";
            if(p == "B") {
                t=t-8;
            }

            if(t < 10) t = "0"+t;
            p+=t;
            return p;
        }
    },
    data() {
        return {
            testid: null,
            xmlconfig: null,
            test: null,
            testduration: 4800, //   -- LIVE SYSTEM
            // testduration: 15, //   -- TEST SYSTEM
            currenttime: 0,
            wells: [],
        }
    },
})
</script>

<style scoped>
table {
    border-collapse: collapse;
}
td {
    border: 1px solid var(--primary-color);
    padding: 5px;
}

.submit {
    padding: 15px;
    margin-top: 15px;
    background-color: var(--primary-color);
    color: var(--secondary-color);
    border: 1px solid var(--primary-color);
    cursor: pointer;
}

progress::-moz-progress-bar { background: blue; }
progress::-webkit-progress-value { background: blue; }
progress { color: blue; }
progress::-webkit-progress-bar { background-color: transparent; width: 100%;}

progress {
    border-radius: 0px;
    position: relative;
    bottom: 14px;
    border: 1px solid var(--primary-color);
    width: 100%;
}

.progressinfo {
    margin: auto;
    width: 600px;
}
.progressinfo div {
    width: 100%;
}
h1 {
    padding: 0px;
    margin: 0px;
    color: var(--primary-color) !important;
    font-size: 18pt;
}

h3 {
    padding: 0px;
    margin: 0px;
    color: var(--primary-color) !important;
    font-weight: 100;
}
.wait {
    height: calc(100% - 30px);
    width: 100%;
    display: flex;
}
</style>
